(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ptk-delivery-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ptk-delivery-estimate')) {
    customElements.define('ptk-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.updateDates();
      }

      disconnectedCallback() {
        clearTimeout(this.refreshTimer);
      }

      updateDates() {
        clearTimeout(this.refreshTimer);
        const today = new Date();
        const locale = this.dataset.locale || 'en';
        const formatter = new Intl.DateTimeFormat(locale, {
          weekday: 'long', month: 'long', day: 'numeric'
        });
        this.querySelectorAll('[data-ptk-arrival-offset]').forEach((element) => {
          const days = Number(element.dataset.ptkArrivalOffset);
          const arrival = new Date(today.getFullYear(), today.getMonth(), today.getDate() + days, 12);
          element.dateTime = `${arrival.getFullYear()}-${String(arrival.getMonth() + 1).padStart(2, '0')}-${String(arrival.getDate()).padStart(2, '0')}`;
          element.textContent = formatter.format(arrival);
        });
        const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        this.refreshTimer = setTimeout(() => this.updateDates(), tomorrow.getTime() - today.getTime() + 1000);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
